import React from "react";
import { TopNavBar } from "@/components/nav/TopNavBar";
import { BottomNav } from "@/components/nav/BottomNav";
import { Brand } from "@/components/nav/Brand";
import { AskTharwy } from "@/components/AskTharwy";
import { FirstDepositCelebration } from "@/components/FirstDepositCelebration";

export { Brand };
export { NotificationBell } from "@/components/nav/NotificationBell";
export const TopNav = TopNavBar;

export const AppShell = ({ children }) => (
  <div className="min-h-screen bg-background">
    <TopNavBar />
    <main className="mx-auto max-w-[1600px] px-4 sm:px-6 lg:px-8 py-6 lg:py-9 pb-28 lg:pb-9 animate-fade-up">{children}</main>
    <AskTharwy />
    <FirstDepositCelebration />
    <BottomNav />
  </div>
);
